import Command from './_Command';

export default class ExecuteCommandController extends Command {
    constructor(
        public readonly Key: string,
        public readonly Path: string,
        public readonly Callback: () => void,
    ) {
        super({
            Enabled: true,
            Key,
            Path,
            Callback,
        });
    }
}
